<template>
  <div class="block yfhw-page17 f-r f-c">
    <PageHeader
      :title="moduleData['3_24_1_1']"
      :sub-title="moduleData['3_24_1_1_en']"
      :page-logo="reportCustomization.pageLogo"
    />
    <PageTips :page-num="pageNum"/>

    <div class="content-container">
      <div class="head-container">
        <div class="left-container">
          <TableNav width="695px" style="margin-bottom: 20px">
            <template v-slot:title>居住热区热度（Top5）</template>
          </TableNav>
          <PTable :col-data="colData" :row-data="rowData" style="height: 375px">
            <Empty text="暂无数据" v-if="!rowData.length"/>
          </PTable>
        </div>

        <div class="right-container">
          <div class="chart-block">
            <div class="title">职业分布（Top15）</div>
            <Empty v-if="barJobEmpty" class="empty-container"></Empty>
            <VChart
              v-else
              style="width: 100%; height: 100%"
              :option="barJobOption"
            ></VChart>
          </div>
        </div>
      </div>

      <div class="tail-container">
        <div class="exp-title">数据说明：</div>
        <div class="exp">
          居住人口热区top5：列举区域内人口密度最大的5个聚集地。
        </div>
        <div class="exp">
          职业分布：指目标客群各类职业占比分布，通过大数据模型进行计算推测。（例如：网约车司机：月平均开车时长大于150分钟 ）
        </div>
      </div>
    </div>

    <div v-if="reportCustomization.showDataSource" class="page-bottom-tips no-gap">
      数据来源：位置厂商数据结合边界自有模型测算
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'

import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import Empty from "./components/Empty"
import TableNav from "./components/TableNav";
import PTable from "./components/PTable";

const props = defineProps({
  pageNum: String,
  moduleData: {
    type: Object,
    default: () => {}
  },
  reportCustomization: {
    type: Object,
    default: () => {},
  },
  commonLang: {
    type: String,
    default: 'zh',
  },
  yfhwData: {
    type: Object,
    default: () => {},
  },
});

// 左侧表格数据
const colData = ref([
  { prop: 'rank', width: '114px', label: 'top排名' },
  { prop: 'name', width: '182px', label: '热区中心点名称' },
  { prop: 'population', width: '200px', label: '区域人流（人次）' },
  { prop: 'distance', width: '190px', label: '直线距离（km）' },
])
const rowData = ref([])

// 职业分布（Top10）
const barJobEmpty = ref(false)
const barJobOption = ref()

const wrapData = () => {
  const { careerList, topResidenceList } = props.yfhwData

  rowData.value = topResidenceList

  barJobEmpty.value = !careerList.length
  barJobOption.value = {
    grid: {
      top: 40,
      left: 94,
      bottom: 60,
      right: 20,
    },
    xAxis: {
      type: 'category',
      data: careerList.map((i) => i.key),
      axisLabel: {
        color: '#595959',
        interval: 0,
        fontSize: '12px',
        rotate: 15,
        align: 'center',
        verticalAlign: 'middle',
        margin: 20,
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        show: true,
        formatter: '{value} %',
        fontSize: '14px',
      },
    },
    series: {
      type: 'bar',
      data: careerList.map((i) => i.value),
      barWidth: 38,
      itemStyle: {
        color: '#4B86FF',
      },
      label: {
        show: true,
        formatter(param) {
          return param.value + '%'
        },
        position: 'top',
        color: '#595959',
        fontSize: '18px',
      },
    },
  }
}

onMounted(() => {
  wrapData()
})
</script>
<style scoped lang="less">
.yfhw-page17 {
  position: relative;
  background: #ffffff;
  padding: 26px 60px 32px 0;

  .content-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 30px 60px 0;
    width: 100%;

    .head-container {
      flex: 1;
      display: flex;
      justify-content: space-around;

      .title {
        margin-left: 22px;
        font-size: 24px;
        color: rgba(0, 0, 0, 0.88);
      }

      .left-container {
        flex-shrink: 0;
        width: 695px;
        display: flex;
        flex-direction: column;
      }

      .right-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 100%;

        .chart-block {
          width: 100%;
          height: 450px;
        }
      }
    }

    .tail-container {
      flex-shrink: 0;
      margin-top: 18px;
      padding: 10px 24px 20px;
      border: 1px solid rgba(0, 0, 0, 0.07);
      border-radius: 16px;

      .exp-title {
        font-size: 24px;
        color: #333333;
        margin-top: 16px;
        margin-left: 20px;
      }

      .exp {
        font-size: 18px;
        margin-top: 10px;
        margin-left: 20px;
        color: #333333;
      }

      .exp::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        vertical-align: middle;
        background-color: #2c75f2;
      }
    }
  }

  .empty-container {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>
